<template>
  <el-dialog
    title="标签管理"
    :visible.sync="visible"
    width="700px"
    append-to-body
    @closed="handleClosed">
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="产品码"
        name="0">
        <label-tag-detail-table ref="ttable" />
      </el-tab-pane>
      <el-tab-pane
        label="箱码"
        name="1">
        <label-set-detail-table ref="stable" />
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <el-dropdown>
        <el-button
          type="warning"
          style="margin-right: 10px">
          标签生产<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="createtag">产品码</el-dropdown-item>
          <el-dropdown-item @click.native="createset">箱码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button @click="toggleModal(false)">关闭</el-button>
      <label-set-produce-modal
        ref="set"
        :fetch="fetchSet" />
      <label-tag-produce-modal
        ref="tag"
        :fetch="fetchTag" />
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import LabelSetDetailTable from './label-set-detail-table.vue'
import LabelTagDetailTable from './label-tag-detail-table.vue'
import LabelSetProduceModal from './label-set-produce-modal.vue'
import LabelTagProduceModal from './label-tag-produce-modal.vue'

export default {
  name: 'LabelModal',
  components: { LabelSetDetailTable, LabelTagDetailTable, LabelSetProduceModal, LabelTagProduceModal },
  props: {
    callback: Function
  },
  data() {
    return {
      activeName: '0',
      loading: false,
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {},
    fetch() {
      this.toggleModal(true)
    },
    createtag() {
      this.$refs.tag.init()
    },
    createset() {
      this.$refs.set.init()
    },
    fetchSet() {
      this.$refs.stable.handleCurrentChange(1)
    },
    fetchTag() {
      this.$refs.ttable.handleCurrentChange(1)
    }
  }
}
</script>
